







































































import {Component, Prop} from "vue-property-decorator";
import {assignValueToForm} from "@/shared/services/helper/utils";
import {FormModel} from "ant-design-vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {LadingCareStatus} from "@/enums/status/ladingcare";
import {LadingCareStore} from "@/modules/ladingcare/store";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";

@Component({
  name: "LadingCareForm",
  components: {EnumSelector}
})
export default class extends mixins(CommonMixin) {
  LadingCareStatus = LadingCareStatus;
  
  @Prop()
  readonly id!: number;

  private form = {
    id: undefined,
    note: "",
    createdBy: "",
    status: undefined
  }

  private billLadingForm = {
    ladingCode: "",
    deliveryEmployee: {
      fullname: "",
    },
    deliveryPartner: {
      name: "",
    }
  }

  private rules = {
    note: [{required: true, message: "Vui lòng nhập nội dung yêu cầu"}]
  }

  private onSubmit() {
    (this.$refs.formLadingCare as FormModel).validate(async valid => {
      if (!valid) return;
      try {
        await LadingCareStore.updateLadingCare(this.form)
        this.$notification.success({
          message: "Thành công",
          description: `Cập nhật thành công`
        });
        this.$router.push({name: "ladingCareServiceList"});
      } catch (e) {
        this.$notification.error({
          message: "Thất bại",
          description: `${e.response?.data?.message || "Cập nhật thất bại"}`
        })
      }
    })
  }

  async created() {
    if (this.id) {
      try {
        const data = await LadingCareStore.singleLadingCare(this.id);
        this.form = assignValueToForm(this.form, data);
        this.billLadingForm = assignValueToForm(this.billLadingForm, data.billLading);
        this.form.createdBy = data.createdBy.employee ? data.createdBy.employee.employeeCode + " - " + data.createdBy.employee.fullname : "";
      } catch (e) {
        this.$notification.error({
          message: "Thất bại",
          description: `${e.response?.data?.message || "Đã có lỗi xảy ra"}`
        })
      }
    }
  }
}
